const protectedRoutes = [
    'pontuacao',
    'campanhas',
    'notificacoes',
    'perfil',
    'perfil/trocar-senha',
    'pedido',
    'pedido-confirmacao',
    'movimentacoes/extrato',
    'movimentacoes/historico',
    'treinamentos',
    'meu-aprendizado',
];

function isProtectedRoute(pathname) {
    const currentPath = pathname || window.location.pathname;

    return protectedRoutes.some(function (page) {
        return currentPath === `/${page}` || currentPath.startsWith(`/${page}/`);
    });
}

window.isProtectedRoute = isProtectedRoute;

function redirectToHome(routes) {
    routes.forEach(function (page) {
        if (window.location.pathname === `/${page}`) {
            window.location.href = '/';
        }
    });
}

function redirectToLogin() {
    localStorage.path = window.location.pathname + window.location.search + window.location.hash;
    window.location.href = '/acesso';
}

window.handleSessionExpired = function () {
    localStorage.removeItem('user_id');
    localStorage.removeItem('token');
    localStorage.removeItem('show_message');
    sessionStorage.clear();

    if (isProtectedRoute()) {
        redirectToLogin();
    }
};

if (!localStorage.getItem('user_id')) {
    if (isProtectedRoute()) {
        redirectToLogin();
    }
} else {
    redirectToHome(['acesso']);
    localStorage.removeItem('path');
}